import { insuredSearch } from '../modules/insureds';
import { itemSearch } from '../modules/items';

// get the fields you want to stick.
export function getInitialStateObject(state) {
  const insuredsSearchState = state.insureds.search;
  const itemsSearchState = state.items.search;
  const navbarExpandedState = state.navbar.isExpanded;

  try {
    return {
      insureds: {
        search: {
          ...insuredSearch.initialState,
          hiddenColumnIds: insuredsSearchState.hiddenColumnIds,
          columnsToggled: insuredsSearchState.columnsToggled
        }
      },
      items: {
        search: {
          ...itemSearch.initialState,
          hiddenColumnIds: itemsSearchState.hiddenColumnIds
        }
      },
      navbar: { isExpanded: navbarExpandedState }
    };
  } catch (e) {
    console.warn(e);
  }

  return {};
}

// convert object to string and store in localStorage
export const saveToLocalStorage = state => {
  try {
    const serialisedState = JSON.stringify(getInitialStateObject(state));
    localStorage.setItem('persistantState', serialisedState);
  } catch (e) {
    console.warn(e);
  }
};

// load string from localStarage and convert into an Object
// invalid output must be undefined
export const loadFromLocalStorage = () => {
  try {
    const serialisedState = localStorage.getItem('persistantState');
    if (serialisedState === null) return undefined;
    return JSON.parse(serialisedState);
  } catch (e) {
    console.warn(e);
    return undefined;
  }
};
